import Text from '../../components/BuildingBlocks/Text';

import * as Styled from './styles';

/**
 * Configuration for RichText used to format and display an MSA.
 */
export const POLICY_WHITELIST = ['h1', 'p', 'strong', 'ul', 'ol', 'li'];
export const POLICY_CONVERTERS = {
  h1: {
    element: Styled.Heading,
    props: { tagName: 'h2' }
  },
  p: {
    element: Styled.Paragraph,
    props: { tagName: 'p' }
  },
  strong: {
    element: Styled.Paragraph,
    props: { tagName: 'strong', weight: 'bold' }
  },
  ul: {
    element: Styled.UnorderedList,
    props: {}
  },
  ol: {
    element: Styled.OrderedList,
    props: {}
  },
  li: {
    element: Styled.ListItem,
    props: { tagName: 'li' }
  }
};

/**
 * Configuration for RichText used for format sub headings.
 *
 * It is used on a few pages to help generate a sub title that can contain
 * bold text, blue text and links.
 */
export const SUB_HEADING_WHITELIST = ['p', 'span', 'strong', 'a'];
export const SUB_HEADING_CONVERTERS = {
  p: {
    element: Text.CopyBody,
    props: { tagName: 'p', color: 'primary', noMargins: true }
  },
  span: {
    element: Text.CopyBody,
    props: { tagName: 'span', color: 'quaternary', noMargins: true }
  },
  strong: {
    element: Text.CopyBody,
    props: { tagName: 'strong', color: 'primary', weight: 'bold', noMargins: true }
  }
};
